import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostFormularKopierenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostFormularKopierenCommandService],
  exports: []
})
export class PostFormularKopierenCommandServiceModule { }
